import React from 'react';

interface LogoProps {
  className?: string;
  width?: number;
  height?: number;
}

const Logo: React.FC<LogoProps> = ({ 
  className = "", 
  width = 160, 
  height = 55 
}) => {
  return (
    <div className={`flex items-center justify-center ${className}`}>
      <img 
        src="/SurePal-Logo.svg" 
        alt="SurePal Logo" 
        width={width}
        height={height}
        className="object-contain"
      />
    </div>
  );
};

export default Logo;